import React, { useState, useEffect } from "react";
import { Flex, Text, Input, Box, Checkbox, Button } from "@chakra-ui/react";
import DynamicSelectInput from "./DynamicSelect";
import DynamicInput from "./DynamicInput"; // Adjust the import based on your setup
import { toast } from "react-toastify";
// import { ToastContainer, toast } from "react-toastify";

const OptionsWithCheckboxes = React.memo(
  ({
    urlOptions,
    colorMain,
    setSelectionDetails,
    amount,
    setIsSelectButtonDisabled,
    setTotalSplitAmountB,
    totalSplitAmountB,
    setAmount,
    setAnyChecked,
    isCheckedAanyChecked,
    isDynamicTotal,
    urlOption,
    isDisabled,
    quantityButtonVisible,
  }) => {
    const [selectedOptions, setSelectedOptions] = useState(
      urlOptions.map((option) => {
        const predefinedAmount = option?.target || 0;
        return {
          name: option.value,
          isChecked: option.value === urlOption,
          amount: predefinedAmount > 0 ? predefinedAmount : "",
          isEditable: predefinedAmount < 1,
          quantity: 1,
          subCategory: "",
        };
      })
    );

    const getSubCategories = (name) =>
      (urlOptions.find((o) => o.value === name)?.subCategories || "")
        .split(",")
        .map((sub) => sub.trim())
        .filter(Boolean);
    const [remainingAmount, setRemainingAmount] = useState(amount);
    const [toastId, setToastId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    // const toast = useToast();

    const handleCheckboxChange = (index) => {
      if (isDisabled) return;
      setSelectedOptions((prevOptions) => {
        const updatedOptions = [...prevOptions];
        const isChecked = !updatedOptions[index].isChecked;
        const predefinedAmount =
          urlOptions.find(
            (option) => option.value === updatedOptions[index].name
          )?.target || 0;
        updatedOptions[index] = {
          ...updatedOptions[index],
          isChecked,
          quantity: 1,
          amount: isChecked
            ? predefinedAmount > 0
              ? predefinedAmount
              : remainingAmount > 0
                ? remainingAmount
                : ""
            : predefinedAmount > 0
              ? predefinedAmount
              : "",
          isEditable: predefinedAmount < 1,
        };

        // Recalculate total amount and remaining amount
        const totalAmount = updatedOptions
          .filter((option) => option.isChecked)
          .reduce((sum, option) => {
            return sum + (parseFloat(option.amount) || 0);
          }, 0);

        const checkedTotalAmount = updatedOptions
          .filter((option) => option.isChecked)
          .reduce((sum, option) => sum + parseFloat(option.amount) || 0, 0);

        // Determine if there are any editable options and non-editable options
        const hasEditableOptions = selectedOptions.some(
          (option) => option.isEditable
        );
        const hasNonEditableOptions = selectedOptions.some(
          (option) => !option.isEditable || !option.amount
        );
        if (hasEditableOptions && hasNonEditableOptions) {
          // console.log(
          //   predefinedAmount,
          //   remainingAmount,
          //   checkedTotalAmount,
          //   totalAmount,
          //   amount
          // );
          setTotalSplitAmountB(totalAmount);
          setAmount(totalAmount);
        }
        if (predefinedAmount && predefinedAmount > 0) {
          console.log(checkedTotalAmount, totalAmount);
          setAmount(checkedTotalAmount);
        }

        setTotalSplitAmountB(totalAmount);
        setAmount(totalAmount);
        setRemainingAmount(0);

        return updatedOptions;
      });
    };

    const handleInputChange = (event, index, type) => {
      // Remove the global isDisabled check to allow editing amounts if they are not predefined
      let { value } = event.target;

      const intValue = parseInt(value, 10) || 0;

      setSelectedOptions((prevOptions) => {
        const updatedOptions = [...prevOptions];
        const option = updatedOptions[index];
        const predefinedAmount =
          urlOptions.find((o) => o.value === option.name)?.target || 0;
        // console.log(option.isEditable);
        // Only update amount if the option is editable
        updatedOptions[index] = {
          ...option,
          [type]: option.isEditable ? intValue : predefinedAmount,
        };

        // Calculate the total amount
        const totalAmount = updatedOptions
          .filter((option) => option.isChecked)
          .reduce((sum, option) => {
            return sum + (parseFloat(option.amount) || 0);
          }, 0);

        const checkedTotalAmount = updatedOptions
          .filter((option) => option.isChecked)
          .reduce((sum, option) => sum + parseFloat(option.amount) || 0, 0);

        // Determine if there are any editable options and non-editable options
        const hasEditableOptions = selectedOptions.some(
          (option) => option.isEditable
        );
        const hasNonEditableOptions = selectedOptions.some(
          (option) => !option.isEditable
        );

        setTotalSplitAmountB(totalAmount);
        setAmount(totalAmount);
        setRemainingAmount(0);
        return updatedOptions;
      });
    };

    const handleQuantityChange = (index, newQuantity) => {
      if (isDisabled) return;
      setSelectedOptions((prevOptions) => {
        const option = prevOptions[index];
        const predefinedAmount =
          urlOptions.find((o) => o.value === option.name)?.target || 0;
        if (predefinedAmount <= 0) return prevOptions;

        const quantity = Math.max(1, newQuantity);
        const updatedOptions = [...prevOptions];
        updatedOptions[index] = {
          ...option,
          quantity,
          amount: predefinedAmount * quantity,
        };

        const totalAmount = updatedOptions
          .filter((o) => o.isChecked)
          .reduce((sum, o) => sum + (parseFloat(o.amount) || 0), 0);

        setTotalSplitAmountB(totalAmount);
        setAmount(totalAmount);
        setRemainingAmount(0);

        return updatedOptions;
      });
    };

    useEffect(() => {
      const allCheckedHaveAmount = selectedOptions
        .filter((option) => option.isChecked)
        .every((option) => {
          const amountStr = String(option.amount).trim();
          const needsSub =
            getSubCategories(option.name).length > 0 && !option.subCategory;
          return amountStr !== "" && !needsSub;
        });

      const checkedOptions = selectedOptions.filter(
        (option) => option.isChecked
      );
      const totalCheckedAmount = checkedOptions.reduce(
        (sum, option) => sum + parseFloat(option.amount || 0),
        0
      );

      const anyChecked = selectedOptions.some((option) => option.isChecked);

      if (allCheckedHaveAmount) {
        setSelectionDetails(
          checkedOptions.map((option) => ({
            ...option,
            name: option.subCategory
              ? `${option.name}#${option.subCategory}`
              : option.name,
          }))
        );
      } else {
        setSelectionDetails([]);
      }
      setIsSelectButtonDisabled(
        !(
          (totalSplitAmountB === parseFloat(amount) || isDynamicTotal) &&
          anyChecked &&
          allCheckedHaveAmount
        )
      );

      const hasEditableOptions = selectedOptions.some(
        (option) => option.isEditable
      );
      const hasNonEditableOptions = selectedOptions.some(
        (option) => !option.isEditable
      );

      if (hasEditableOptions && hasNonEditableOptions) {
        setIsSelectButtonDisabled(!allCheckedHaveAmount);
      }
      setAnyChecked(anyChecked);

      // setRemainingAmount(
      //   parseFloat(amount) - parseFloat(totalSplitAmountB) || 0
      // );

      // Update remaining amount based on the total amount and predefined amounts
      let remaining = parseFloat(amount) - totalCheckedAmount;

      // Adjust remaining amount if any of the checked options have predefined amounts
      checkedOptions.forEach((option) => {
        const predefinedAmount =
          urlOptions.find((o) => o.value === option.name)?.target || 0;

        if (predefinedAmount > 0) {
          remaining += predefinedAmount - parseFloat(option.amount || 0);
        }
      });

      setRemainingAmount(remaining);
    }, [
      urlOptions,
      selectedOptions,
      totalSplitAmountB,
      amount,
      setSelectionDetails,
      setIsSelectButtonDisabled,
      setAnyChecked,
    ]);

    useEffect(() => {
      const updatedOptions = selectedOptions.map((option) => ({
        ...option,
        amount: option.amount.toString().replace(/^0+(?!\.)/, ""),
      }));

      // Update state only if there is a change
      setSelectedOptions((prevOptions) => {
        if (JSON.stringify(prevOptions) !== JSON.stringify(updatedOptions)) {
          return updatedOptions;
        }
        return prevOptions;
      });
    }, [selectedOptions]);

    useEffect(() => {
      if (!isDynamicTotal && amount > 0) {
        const checkedEditableOptions = selectedOptions.filter(o => o.isChecked && o.isEditable);
        if (checkedEditableOptions.length === 1) {
          const index = selectedOptions.findIndex(o => o.isChecked && o.isEditable);
          const otherOptionsAmount = selectedOptions
            .filter((o, i) => o.isChecked && i !== index)
            .reduce((sum, o) => sum + (parseFloat(o.amount) || 0), 0);

          const newAmount = Math.max(0, parseFloat(amount) - otherOptionsAmount);

          if (parseFloat(selectedOptions[index].amount || 0) !== newAmount) {
            setSelectedOptions(prev => {
              const next = [...prev];
              next[index] = { ...next[index], amount: newAmount };
              return next;
            });
          }
        }
      }
    }, [amount, isDynamicTotal]);

    return (
      <Box w="100%">
        {isCheckedAanyChecked && remainingAmount !== 0 && (
          <Box
            mb={4}
            p={3}
            borderRadius="md"
            bg={remainingAmount < 0 ? "red.50" : "orange.50"}
            borderLeft="4px solid"
            borderColor={remainingAmount < 0 ? "red.400" : "orange.400"}
          >
            <Text
              fontSize="xs"
              fontFamily="poppins"
              fontWeight="bold"
              color={remainingAmount < 0 ? "red.700" : "orange.700"}
              textTransform="uppercase"
              letterSpacing="wider"
            >
              {remainingAmount < 0
                ? `Limit Exceeded: KES ${Math.abs(remainingAmount).toLocaleString()}`
                : `Balance to Allocate: KES ${remainingAmount.toLocaleString()}`}
            </Text>
          </Box>
        )}

        {/* Search Bar */}
        {selectedOptions.length > 7 && (
          <Box mb={4} px={1}>
            <Input
              placeholder="Search items..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              bg="white"
              variant="filled"
              borderRadius="md"
            />
          </Box>
        )}

        <Box
          maxH={selectedOptions.length > 7 ? "60vh" : "unset"}
          overflowY={selectedOptions.length > 7 ? "auto" : "visible"}
          px={1}
          css={{
            '&::-webkit-scrollbar': { width: '4px' },
            '&::-webkit-scrollbar-track': { width: '6px' },
            '&::-webkit-scrollbar-thumb': { background: 'gray', borderRadius: '24px' },
          }}
        >
          {selectedOptions
            .map((option, index) => ({ ...option, originalIndex: index }))
            .filter((option) =>
              option.name.toLowerCase().includes(searchQuery.toLowerCase())
            )
            .map((option) => {
              const index = option.originalIndex;
              const target =
                urlOptions.find((o) => o.value === option.name)?.target || 0;
              const showQuantity = quantityButtonVisible && target > 0;
              return (
                <Box
                  key={index}
                  w="100%"
                  bg="gray.50"
                  p={6}
                  borderRadius="xl"
                  mb={4}
                  transition="all 0.3s"
                >
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    cursor="pointer"
                    onClick={() => handleCheckboxChange(index)}
                  >
                    <Flex alignItems="center">
                      <Checkbox
                        isChecked={option.isChecked}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleCheckboxChange(index);
                        }}
                        colorScheme="teal"
                        size="lg"
                        mr={4}
                        borderColor="gray.400"
                        isDisabled={isDisabled}
                      />
                      <Text fontWeight="bold" fontSize="lg" color="gray.700">
                        {option.name}
                      </Text>
                    </Flex>
                  </Flex>

                  {option.isChecked && (
                    <Box mt={6} pt={4} borderTop="1px solid" borderColor="gray.200">
                      {getSubCategories(option.name).length > 0 && (
                        <Box mb={4} onClick={(e) => e.stopPropagation()}>
                          <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={2} textTransform="uppercase">
                            Subcategory
                          </Text>
                          <DynamicSelectInput
                            options={getSubCategories(option.name).map((sub) => ({ value: sub }))}
                            value={option.subCategory}
                            placeholder="Select a subcategory"
                            isDisabled={isDisabled}
                            onChange={(e) =>
                              setSelectedOptions((prev) => {
                                const next = [...prev];
                                next[index] = { ...next[index], subCategory: e.target.value };
                                return next;
                              })
                            }
                          />
                        </Box>
                      )}
                      {showQuantity ? (
                        <Flex w="100%" justifyContent="space-between" alignItems="flex-end">
                          <Flex flexDir="column">
                            <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={1} textTransform="uppercase">
                              Price
                            </Text>
                            <Text fontSize="2xl" fontWeight="bold" color="gray.800" lineHeight="1">
                              {(target * (option.quantity || 1)).toLocaleString()}
                            </Text>
                          </Flex>
                          <Flex flexDir="column" alignItems="flex-end">
                            <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={2} textTransform="uppercase">
                              Quantity
                            </Text>
                            <Flex
                              alignItems="center"
                              border="1px solid"
                              borderColor="gray.200"
                              borderRadius="lg"
                              bg="white"
                              overflow="hidden"
                              h="40px"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Button
                                size="sm"
                                onClick={() => handleQuantityChange(index, (option.quantity || 1) - 1)}
                                variant="ghost"
                                borderRadius="none"
                                _hover={{ bg: "gray.50" }}
                                h="100%"
                                w="40px"
                                fontSize="xl"
                                fontWeight="medium"
                                color="gray.600"
                                isDisabled={isDisabled || (option.quantity || 1) <= 1}
                              >-</Button>
                              <Input
                                type="number"
                                variant="unstyled"
                                value={option.quantity || 1}
                                onChange={(e) => handleQuantityChange(index, parseInt(e.target.value, 10) || 1)}
                                min={1}
                                textAlign="center"
                                w="50px"
                                fontSize="lg"
                                fontWeight="semibold"
                                isDisabled={isDisabled}
                              />
                              <Button
                                size="sm"
                                onClick={() => handleQuantityChange(index, (option.quantity || 1) + 1)}
                                variant="ghost"
                                borderRadius="none"
                                _hover={{ bg: "gray.50" }}
                                h="100%"
                                w="40px"
                                fontSize="xl"
                                fontWeight="medium"
                                color="gray.600"
                                isDisabled={isDisabled}
                              >+</Button>
                            </Flex>
                          </Flex>
                        </Flex>
                      ) : (
                        <Flex flexDir="column" w="100%">
                          <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={2} textTransform="uppercase">
                            Amount
                          </Text>
                          <DynamicInput
                            type="number"
                            min="1"
                            mb={0}
                            value={option.amount}
                            onChange={(e) => handleInputChange(e, index, "amount")}
                            isReadOnly={!option.isEditable}
                            placeholder="Enter Amount"
                            onClick={(e) => e.stopPropagation()}
                          />
                          {!option.amount && (
                            <Text fontSize="xs" color="red.500" mt={1}>
                              Amount is required
                            </Text>
                          )}
                        </Flex>
                      )}
                    </Box>
                  )}
                </Box>
              );
            })}
        </Box>
      </Box>
    );
  }
);

export default OptionsWithCheckboxes;
